import * as types from "./actionTypes";

export const get =() =>{
  return {
    type: types.FUND_LIST_REQUEST
  }
};
export const getListSuccess =(data) =>{
  return {
    type: types.FUND_LIST_SUCCESS,
    payLoad:data
  }
};
export const getListFailure =(data) =>{
  return {
    type: types.FUND_LIST_FAILURE
  }
};

export const getAllRequest =() =>{
  return {
    type: types.FUND_ALL_REQUEST
  }
};
export const getAllSuccess =(data) =>{
  return {
    type: types.FUND_ALL_SUCCESS,
    payLoad:data
  }
};
export const getAllFailure =(data) =>{
  return {
    type: types.FUND_ALL_FAILURE
  }
};

export const showRequest =(id) =>{
  return {
    type: types.FUND_SHOW_REQUEST,
    id: id
  }
};
export const showSuccess =(data) =>{
  return {
    type: types.FUND_SHOW_SUCCESS,
    payLoad:data
  }
};
export const showFailure =(data) =>{
  return {
    type: types.FUND_SHOW_FAILURE
  }
};

export const storeRequest = data => {
  return{
    type: types.FUND_STORE_REQUEST,
    data: data
  }
};

// TODO: this duplicate of storeRequest
export const store = data => {
    return storeRequest(data)
};

export const storeSuccess = data => {
  return{
    type: types.FUND_STORE_SUCCESS,
    payLoad: data
  }
};
export const storeFailure = () => {
  return{
    type: types.FUND_STORE_FAILURE
  }
};

export const updateRequest = (id, data) => {
  return{
    type: types.FUND_UPDATE_REQUEST,
    id: id,
    data: data
  }
};
export const updateSuccess = data => {
  return{
    type: types.FUND_UPDATE_SUCCESS,
    payLoad: data
  }
};
export const updateFailure = () => {
  return{
    type: types.FUND_UPDATE_FAILURE
  }
};

export const setDefaultRequest = data => {
  return {
    type: types.FUND_SET_DEFAULT_REQUEST,
    data: data
  }
};
export const setDefaultSuccess = data => {
  return{
    type: types.FUND_SET_DEFAULT_SUCCESS,
    payLoad: data
  }
};
export const setDefaultFailure = () => {
  return{
    type: types.FUND_SET_DEFAULT_FAILURE
  }
};

export const removeRequest = data => {  
  return {
    type: types.FUND_REMOVE_REQUEST,
    data: data
  }
};
export const removeSuccess = (id, data) => {
  return{
    type: types.FUND_REMOVE_SUCCESS,
    payLoad: {
      id: id,
      data: data
    }
  }
};
export const removeFailure = () => {
  return{
    type: types.FUND_REMOVE_FAILURE
  }
};